import { createContext, useState, ReactNode, useContext } from 'react';
import agent from '../services/api';
import { calendlyAuthURLPayloadModel, getCalendlyAuthURLResponseModel, getCalendlyIntegrationResponseModel, getCallbackStatusResponseModel, postChatbotCalendlyEventTypeDataPayloadModel, PostChatbotCalendlyEventTypeDataResponseModel, chatbotCalendlyDataInterface, calendlyEventTypeCustomQueDataModel, fieldData, CommonResponseModelWODataArray, calendlyAuthUrlApiCallResponse, CommonResponseModel, responseDataModel } from '../models/axiosModel';

export interface CalendlyContextType {
    selectedEvent: number[];
    setSelectedEvent: React.Dispatch<React.SetStateAction<number[]>>;
    fieldData: fieldData[];
    setFieldData: React.Dispatch<React.SetStateAction<fieldData[]>>;
    isPopupMode: boolean | null;
    setIsPopupMode: (eventName: boolean) => void;
    step: string | null;
    setStep: (eventName: string) => void;
    calendlyAuthData: getCalendlyAuthURLResponseModel | null;
    setCalendlyAuthData: React.Dispatch<React.SetStateAction<getCalendlyAuthURLResponseModel | null>>;
    calendlyAuthUrlApi: (payload: calendlyAuthURLPayloadModel) => Promise<CommonResponseModelWODataArray<calendlyAuthUrlApiCallResponse>>;
    callbackSuccessData: getCallbackStatusResponseModel | null;
    setCallbackSuccessData: React.Dispatch<React.SetStateAction<getCallbackStatusResponseModel | null>>;
    GetCallbackStatus: (state: string) => Promise<CommonResponseModelWODataArray<getCallbackStatusResponseModel>>;
    calendlyIntegrationData: getCalendlyIntegrationResponseModel[] | null;
    setCalendlyIntegrationData: React.Dispatch<React.SetStateAction<getCalendlyIntegrationResponseModel[] | null>>;
    GetCalendlyIntegrationData: (calendly_integration_id: string) => Promise<CommonResponseModel<getCalendlyIntegrationResponseModel>>;
    resetChatbotCalendlyData: () => void;
    chatbotCalendlyEventTypeData: PostChatbotCalendlyEventTypeDataResponseModel[] | null;
    setChatbotCalendlyEventTypeData: React.Dispatch<React.SetStateAction<PostChatbotCalendlyEventTypeDataResponseModel[] | null>>;
    PostChatbotCalendlyEventTypeData: (payload: postChatbotCalendlyEventTypeDataPayloadModel) => Promise<CommonResponseModel<PostChatbotCalendlyEventTypeDataResponseModel>>;
    flagAddAccount: boolean;
    setFlagAddAccount: React.Dispatch<React.SetStateAction<boolean>>;
    genericChatbotCalendlyData: chatbotCalendlyDataInterface[] | null;
    setGenericChatbotCalendlyData: React.Dispatch<React.SetStateAction<chatbotCalendlyDataInterface[] | null>>;
    editAccDetailPopupOpen: boolean;
    setEditAccDetailPopupOpen: React.Dispatch<React.SetStateAction<boolean>>;
    DeleteChatbotCalendlyIntegration: (calendly_integration_id: string, chatbot_id: string) => Promise<CommonResponseModelWODataArray<responseDataModel>>;
    GetGenericCalendlyData: () => Promise<CommonResponseModel<(Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">)>>;
    genericCalendlyData: (Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">)[] | null;
    setGenericCalendlyData: React.Dispatch<React.SetStateAction<(Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">)[] | null>>;
    connectedAccountsArray: Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">[],
    setConnectedAccountsArray: React.Dispatch<React.SetStateAction<Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">[]>>,
    integratedAccountsArray: Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">[],
    setIntegratedAccountsArray: React.Dispatch<React.SetStateAction<Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">[]>>,
}

const CalendlyContext = createContext<CalendlyContextType | undefined>(undefined);

const CalendlyProvider = ({ children }: { children: ReactNode }) => {

    const [selectedEvent, setSelectedEvent] = useState<number[]>([]);
    const [isPopupMode, setIsPopupMode] = useState<boolean | null>(false);
    const [step, setStep] = useState<string | null>('1')
    const [calendlyAuthData, setCalendlyAuthData] = useState<getCalendlyAuthURLResponseModel | null>(null)
    const [callbackSuccessData, setCallbackSuccessData] = useState<getCallbackStatusResponseModel | null>(null)
    const [calendlyIntegrationData, setCalendlyIntegrationData] = useState<getCalendlyIntegrationResponseModel[] | null>(null)
    const [chatbotCalendlyEventTypeData, setChatbotCalendlyEventTypeData] = useState<PostChatbotCalendlyEventTypeDataResponseModel[] | null>(null)
    const [saveBtn, setSaveBtn] = useState<boolean | null>(null)
    const [genericChatbotCalendlyData, setGenericChatbotCalendlyData] = useState<chatbotCalendlyDataInterface[] | null>(null)
    const [editAccDetailPopupOpen, setEditAccDetailPopupOpen] = useState<boolean>(false)
    const [flagAddAccount, setFlagAddAccount] = useState<boolean>(false)
    const [fieldData, setFieldData] = useState<fieldData[]>([])
    const [genericCalendlyData, setGenericCalendlyData] = useState<(Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">)[] | null>(null)
    const [connectedAccountsArray, setConnectedAccountsArray] = useState<Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">[]>([])
    const [integratedAccountsArray, setIntegratedAccountsArray] = useState<Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">[]>([])


    const resetChatbotCalendlyData = () => {
        setStep('1');
        setCalendlyIntegrationData(null)
        setSelectedEvent([])
        setGenericChatbotCalendlyData(null)
        setConnectedAccountsArray([])
        setIntegratedAccountsArray([])
    }

    const calendlyAuthUrlApi = async (payload: calendlyAuthURLPayloadModel): Promise<CommonResponseModelWODataArray<calendlyAuthUrlApiCallResponse>> => {
        const response = await agent.calendlyAuthUrlApi.post(payload);
        if (response.status) {
            setCalendlyAuthData(response?.data);
        }
        return response
    };

    const GetCallbackStatus = async (state: string): Promise<CommonResponseModelWODataArray<getCallbackStatusResponseModel>> => {
        const response = await agent.getCallbackStatus.get(state);
        if (response) {
            setCallbackSuccessData(response?.data);
        }
        return response
    }

    const GetCalendlyIntegrationData = async (calendly_integration_id: string): Promise<CommonResponseModel<getCalendlyIntegrationResponseModel>> => {
        const response = await agent.getCalendlyIntegrationData.get(calendly_integration_id);
        if (response.status) {
            setCalendlyIntegrationData(response?.data)
        }
        return response
    }

    const GetGenericCalendlyData = async (): Promise<CommonResponseModel<(Omit<getCalendlyIntegrationResponseModel, "calendly_event_type_data">)>> => {
        const response = await agent.getCalendlyIntegrationData.get();
        if (response.status) {
            setGenericCalendlyData(response?.data)
        }
        return response
    }

    const PostChatbotCalendlyEventTypeData = async (payload: postChatbotCalendlyEventTypeDataPayloadModel): Promise<CommonResponseModel<PostChatbotCalendlyEventTypeDataResponseModel>> => {
        const response = await agent.postChatbotCalendlyEventTypeData.post(payload)
        if (response.status) {
            setChatbotCalendlyEventTypeData(response?.data)
        }
        return response
    }

    const DeleteChatbotCalendlyIntegration = async (calendly_integration_id: string, chatbot_id: string): Promise<CommonResponseModelWODataArray<responseDataModel>> => {
        const response = await agent.deleteChatbotCalendlyIntegration.delete(calendly_integration_id, chatbot_id)
        // if (response.status) {
        //     return Response
        // }
        return response;
    }

    const payload: CalendlyContextType = {
        selectedEvent,
        setSelectedEvent,
        fieldData,
        setFieldData,
        isPopupMode,
        setIsPopupMode,
        step,
        setStep,
        calendlyAuthData,
        setCalendlyAuthData,
        calendlyAuthUrlApi,
        GetCallbackStatus,
        callbackSuccessData,
        setCallbackSuccessData,
        calendlyIntegrationData,
        setCalendlyIntegrationData,
        GetCalendlyIntegrationData,
        resetChatbotCalendlyData,
        setChatbotCalendlyEventTypeData,
        chatbotCalendlyEventTypeData,
        PostChatbotCalendlyEventTypeData,
        flagAddAccount,
        setFlagAddAccount,
        genericChatbotCalendlyData,
        setGenericChatbotCalendlyData,
        editAccDetailPopupOpen,
        setEditAccDetailPopupOpen,
        DeleteChatbotCalendlyIntegration,
        GetGenericCalendlyData,
        genericCalendlyData,
        setGenericCalendlyData,
        connectedAccountsArray,
        setConnectedAccountsArray,
        integratedAccountsArray,
        setIntegratedAccountsArray
    };

    return (
        <CalendlyContext.Provider value={payload}>
            {children}
        </CalendlyContext.Provider>
    );
};

export { CalendlyContext, CalendlyProvider };
